module.exports = __webpack_public_path__ + "static/media/cq_ultimo_mese.024a1d00.svg";